export const EDIT_CONTRATO = "EDIT_CONTRATO";
export const SAVE_CONTRATO = "SAVE_CONTRATO";
export const SELECT_CONTRATO = "SELECT_CONTRATO";
export const CREATE_CONTRATO = "CREATE_CONTRATO";
export const SELECTING_CONTRATO = "SELECTING_CONTRATO";
export const CONTRATOS_RECIBIDOS = "CONTRATOS_RECIBIDOS";
export const CANCEL_EDIT_CONTRATO = "CANCEL_EDIT_CONTRATO";
export const SET_PROPERTY_CONTRATO = "ST_PROPERTY_CONTRATO";
